import { gql } from '@apollo/client';

export const RELEASE_TRADE_MUTATION = gql`
  mutation ReleaseTrade($id: Int!) {
    p {
      releaseTrade(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
